import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Typography
} from '@mui/material';
import { FC } from 'react';

type FileSizeWarningModalViewProps = {
  setOpenWarning: Function;
  openWarning: {
    status: boolean;
    type: string;
  };
};
const FileSizeWarningModal: FC<FileSizeWarningModalViewProps> = ({
  setOpenWarning,
  openWarning
}) => {
  return (
    <>
      <Dialog
        open={openWarning?.status}
        keepMounted
        onClose={() => setOpenWarning(false)}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <Typography variant="h5">
              {openWarning?.type === 'size'
                ? 'Certain selected file(s) have exceeded the size limit'
                : 'Certain selected file(s) have unsupported format'}
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            onClick={() => {
              setOpenWarning(false);
            }}
            variant="contained"
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default FileSizeWarningModal;
